import { useAppDispatch } from '../../redux/hooks'
import { searchDataUpdated } from '../../redux/reducers/searchSlice'
import { instructorSearchConnector } from '../../server/connector/InstructorSearchConnector'
import CtaButton from '../../components/ctaButton/CtaButton'
import './style.scss'

function ShowMoreSection() {
	const dispatch = useAppDispatch()

	const showMoreClickHandler = () => {
		console.log('show more click handler')
		instructorSearchConnector.performSearchRequest().then((successRequest) => {
			dispatch(searchDataUpdated())
			if (!successRequest) {
				console.log('WARNING - [App] - performSearchRequest() failed')
			}
		})
	}

	return (
		<div className='section-content d-f'>
			<div className='show-more-section'>
				<CtaButton
					label='Show More'
					size='medium'
					onClick={() => { showMoreClickHandler() }}
				/>
			</div>
		</div>
	)
}

export default ShowMoreSection
